<template>
  <section class="is-hidden-tablet"> 
    
    <div class="qr-codescan" v-if="openQrScanner">
      <span class="close-qr-reader" @click.prevent="openQrScanner = false"><img src="@/assets/img/close_24px.png"/></span>
      <div class="qr-code-frame">
         <qrcode-stream  @decode="onDecode"></qrcode-stream>
      </div>
    </div>
   
    <!-- action wrap -->
    <div  :class="(filterScreen == 1 ? 'active' : '') + ' mobile-filter-actions-wrap default-mobile-actions'">
     <div class="mobile-filter-actions-manage">
       <div class="open-filter-modal-wrap">
         <a href="#" @click.prevent="changeScreen(2)" class="open-filter-modal"><i class="fas fa-angle-up"></i></a> 
       </div>
        <a v-if="inStore" class="button bg-secondary text-white" @click.prevent="openQrScanner = true">SCAN ANOTHER</a>
        <router-link v-else class="button bg-secondary text-white" :to="{ name: 'StoreProfile', params: { business_slug: $route.params.business_slug , store_slug: $route.params.store_slug}, query: $route.query}">BACK</router-link>
        <a class="button bg-secondary text-white" @click.prevent="changeScreen(3)">SELECT SIZE</a>

     </div>
    </div>
    <!-- action wrap ends -->

    <!-- action with menu wrap -->
    <div :class="(filterScreen == 2 ? 'active' : '') + ' mobile-action-withmenu-options-wrap'">
      <div class="mobile-action-menus">
        <a class="button is-fullwidth mb-3" @click.prevent="moveToUserFavorites()">FAVORITES</a>
      </div>
      <div class="mobile-filter-actions-wrap">
        <div class="mobile-filter-actions-manage">
          <div class="open-filter-modal-wrap">
            <a href="#" @click.prevent="changeScreen(1)" class="open-filter-modal"><i class="fas fa-angle-down"></i></a> 
          </div>
          <router-link class="button bg-secondary text-white" :to="{ name: 'StoreProfile', params: { business_slug: $route.params.business_slug , store_slug: $route.params.store_slug}, query: $route.query}">BACK</router-link>
          <a class="button bg-secondary text-white" @click.prevent="showSidebarCart()">CART</a>
        </div>
      </div>
    </div>
    <!-- action with menu wrap ends -->

     <!-- action with filter wrap -->
    <div :class="(filterScreen == 3 ? 'active' : '') + ' mobile-action-with-filter-wrap'">
      <div class="mobile-filters-wrap mobile-select-prod-size">
        <add-to-stash-main 
        :productvariants="productvariants"
        :outofStockSubscribeVariants="outofStockSubscribeVariants"
        :product="productdetail" />
      </div>
      <div class="mobile-filter-actions-wrap">
      <div class="mobile-filter-actions-manage">
          <div class="open-filter-modal-wrap">
            <a href="#" @click.prevent="changeScreen(1)" class="open-filter-modal"><i class="fas fa-angle-down"></i></a> 
          </div>
          <button class="button bg-secondary text-white" @click.prevent="changeScreen(1)">BACK</button>
          <button class="button bg-secondary text-white" @click.prevent="showSidebarCart()">VIEW CART</button>
        </div>
      </div>
    </div>
    <!-- action with filter wrap ends -->



  </section>
</template>

<script>
import { mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
import AddToStashMain from '@/Components/Pages/PageComponents/LocationProductDetailNew/AddToStashMain';

export default {
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
    AddToStashMain
  },
  props: {
    productdetail: {
      require: true,
      type: Object,
    },
    outofStockSubscribeVariants: {
      required: true,
      type: Array,
    },
    productvariants: {
      require: true,
      type: Array,
    }
  },
  data() {
    return {
      openQrScanner: false,
      filterScreen: 1,
      totalAddableVariant: 0,
      error: '',
    }
  },
  computed: {
    inStore() {
      if( (this.$route.query.in_store == 1) || (this.$route.query.in_store == 'true')){
        return true;
      }
      return false;
    },
  },

  mounted() {
    //this.totalAddableVariant = Helpers.getTotalNumberOfAddableVariants(this.variants);
  },

  methods: {
    changeScreen(val) {
      this.filterScreen = val;
    },
    /**
     * Move to favourites
     */
    moveToUserFavorites() {
      if(this.$store.getters.getLoggedInUserToken){
        this.$router.push({
          name: 'UserFavouriteProducts',
          params: { 
            business_slug: this.$route.params.business_slug, 
            store_slug: this.$route.params.store_slug }
        })
      } else {
        this.va_snackbar({
          message:  'Please login to proceed.',
          type: 'error',
        });
      }
    },
    
    /**
     * Open sidebar cart
     */
    showSidebarCart() {
      this.changeScreen(1);
      bus.$emit('open-sidebar-cart', true);
    },

    onDecode (decodedString) {
     this.openQrScanner = false;
     window.location.href = decodedString; 
    },

    ...mapActions({
      va_snackbar: "snackbar/setSnackbar",
    })
  },
}
</script>
<style >
.qr-codescan{
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 30px;
  z-index: 999;
  padding-bottom: 60px;
}
.close-qr-reader {
    margin-bottom: 30px;
    display: inline-block;
    cursor: pointer;
}
.qr-code-frame {
    height: calc(100% - 60px);
    position: relative;
    overflow: hidden;
}
</style>